import { Language } from '@flowus/common/hooks/use-language';
import en from './en.json';
import zhHans from './zh-hans.json';
import zhHant from './zh-hant.json';
import ru from './ru.json';
import ja from './ja.json';
import de from './de.json';
import es from './es.json';

export const translationResources = {
  [Language.en]: {
    translation: en,
    ...en,
  },
  [Language.zhHans]: {
    translation: zhHans,
    ...zhHans,
  },
  [Language.zhHans.toLowerCase()]: {
    translation: zhHans,
    ...zhHans,
  },
  [Language.zhHant]: {
    translation: zhHant,
    ...zhHant,
  },
  [Language.zhHant.toLowerCase()]: {
    translation: zhHant,
    ...zhHant,
  },
  [Language.ru]: {
    translation: ru,
    ...ru,
  },
  [Language.ja]: {
    translation: ja,
    ...ja,
  },
  [Language.de]: {
    translation: de,
    ...de,
  },
  [Language.es]: {
    translation: es,
    ...es,
  },
};

export const LanguageKey = 'next_lng';
